import { getValueFromUA } from '@/asset/js/utils';
const config = window.config || {};
window.config = config;
export const initCountry = () => {
  let clientLang;
  let clientCountry;
  clientLang = getValueFromUA('lang');
  clientCountry = getValueFromUA('country');
  const params = URL.getPara(true);
  let paramLanguage;
  let paramCountry;
  if (params.lang) {
    paramLanguage = params.lang;
  }
  if (params.country) {
    paramCountry = params.country;
  }
  config.lang = paramLanguage || clientLang || 'en';
  config.country = paramCountry || clientCountry || null;
};
initCountry();
